import { render, staticRenderFns } from "./list.vue?vue&type=template&id=2aaf1e4a&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=2aaf1e4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf1e4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aaf1e4a')) {
      api.createRecord('2aaf1e4a', component.options)
    } else {
      api.reload('2aaf1e4a', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=2aaf1e4a&scoped=true&", function () {
      api.rerender('2aaf1e4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/quota/list.vue"
export default component.exports